export default __webpack_public_path__ + "static/media/logo_krayen_cropped.684e69f8.png";